/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable default-case */
// importing types from constants definded in constant/ index file
import * as storage from "../services/localStorage";
import { LOGIN, SIGN_UP, LOG_OUT, UPDATE_AUTH } from "../constant/index";
import { pickUserType } from "../utils/userTypes";
import { resolveMediaUrl } from "../../utils/userIdentity";

const INITIAL_STATE = {
  SIGN_UP_done: false,
  loging: false,
  creating: false,
  isLogedin: false,
  token: "",
  expiry: "",
  email: "",
  firstname: "",
  lastname: "",
  username: "",
  id: "",
  image: "",
  type: null,
};

function pickStoredImage(source = {}, nested = {}) {
  const raw =
    source.image ||
    source.image_url ||
    source.profile_image ||
    nested.image ||
    nested.profile_image ||
    "";
  return resolveMediaUrl(raw) || "";
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // ---------------------------------- login cases ---------------------------------- //
    case `${LOGIN}_REQUEST`:
      return {
        ...INITIAL_STATE,
        loging: true,
      };
    case `${LOGIN}_SUCCESS`: {
      const payload = action.payload || {};
      const user = payload.user || {};
      const userType = pickUserType(payload, user);
      // Flatten user into storage (display name / id lookups) while keeping
      // Redux shape compatible with the rest of the dealers app.
      const stored = {
        ...state,
        ...payload,
        ...user,
        firstname:
          user.firstname ||
          user.first_name ||
          payload.firstname ||
          payload.first_name ||
          state.firstname ||
          "",
        lastname:
          user.lastname ||
          user.last_name ||
          payload.lastname ||
          payload.last_name ||
          state.lastname ||
          "",
        username: user.username || payload.username || state.username || "",
        email: user.email || payload.email || state.email || "",
        id: user.id || payload.id || state.id || "",
        image: pickStoredImage(payload, user) || state.image || "",
        token: payload.token || state.token || "",
        expiry: payload.expiry || state.expiry || "",
        type: userType,
        loging: false,
        isLogedin: true,
      };
      storage.set({
        key: "auth",
        data: stored,
      });
      return {
        ...state,
        loging: false,
        ...payload,
        ...user,
        firstname: stored.firstname,
        lastname: stored.lastname,
        username: stored.username,
        email: stored.email,
        id: stored.id,
        image: stored.image,
        token: stored.token,
        expiry: stored.expiry,
        type: stored.type,
        isLogedin: true,
      };
    }
    case `${LOGIN}_FAIL`:
    case `${LOGIN}_ERROR`:
      return {
        ...state,
        loging: false,
      };

    case UPDATE_AUTH: {
      const patch = { ...(action.payload || {}) };
      if (Object.prototype.hasOwnProperty.call(patch, "image")) {
        const nextImage = resolveMediaUrl(patch.image);
        if (!nextImage && state.image) {
          delete patch.image;
        } else {
          patch.image = nextImage;
        }
      }
      const nextState = {
        ...state,
        ...patch,
      };
      storage.set({
        key: "auth",
        data: nextState,
      });
      return nextState;
    }

    case `${SIGN_UP}_REQUEST`:
      return {
        ...INITIAL_STATE,
        creating: true,
      };
    case `${SIGN_UP}_SUCCESS`:
      return {
        ...state,
        SIGN_UP_done: action.payload,
      };
    case `${SIGN_UP}_FAIL`:
    case `${SIGN_UP}_ERROR`:
      return {
        ...state,
        creating: false,
      };
    case LOG_OUT:
      storage.remove({
        key: "auth",
      });
      return INITIAL_STATE;
  }
  return state;
};
